module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginbox"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mp),
      expression: "mp",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "tel",
    attrs: {
      "type": "number",
      "placeholder": "手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value.trim()
      }, _vm.onlyNum],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.countDown) ? _c('span', {
    staticClass: "get-code"
  }, [_vm._v(_vm._s(_vm.time) + "s")]) : _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.postSmsCaptcha
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.captcha),
      expression: "captcha",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "number",
      "placeholder": "验证码",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.postSignIn.apply(null, arguments)
      }
    }
  }, [_vm._v("绑定手机号")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2848b143","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/BindPhone.vue
// module id = 419
// module chunks = 7